<div class="container">
  <div class="row">
    <div class="col-12 mb-5">
      <app-toolkit-page-title title="Ricerca atto di finanziamento">
        <button type="button" class="btn btn-outline-primary mt-3" [routerLink]="['../inserisci']">
          <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
          <span class="d-none d-md-inline-block">Inserisci atto di finanziamento</span>
        </button>
      </app-toolkit-page-title>
      <div class="card">
        <div class="card-body">
          <form class="form" role="form" [formGroup]="criteriaForm" (ngSubmit)="submitForm()">
            <div class="form-row pt-2">
              <h6 class="col-12">Ricerca atto di finanziamento</h6>
              <div class="form-group col-md-12">
                <label for="descrizione">Atto di finanziamento</label>
                <input class="form-control" id="descrizione" formControlName="descrizione" type="text" />
              </div>
            </div>
            <div class="button-actions">
              <button type="button" class="btn btn-outline-primary" (click)="resetForm()">
                Pulisci
              </button>
              <button type="submit" class="btn btn-primary">Ricerca</button>
            </div>
          </form>
        </div>
      </div>
      <div class="card mt-4">
        <div class="card-body">
          <h6 id="table_description">Risultati ricerca</h6>
          <div style="transform: rotateX(180deg)" class="table-responsive mb-3">
            <table style="transform: rotateX(180deg)" class="table table-striped table-sm"
              aria-describedby="table_description">
              <thead class="thead-light">
                <tr>
                  <th scope="col">
                    Atto di finanziamento</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tableData">
                  <td>{{ item.descrizione }}</td>
                  <td class="actions">
                    <button aria-label="Modifica atto di finanziamento" type="button" class="btn btn-xs btn-link" container="body"
                      ngbTooltip="Modifica atto di finanziamento" (click)="modificaLegge(item)">
                      <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="!tableData.length">
                  <td colspan="8">
                    <p class="mb-0 text-center">Nessun risultato trovato.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ngb-pagination *ngIf="tableData.length" [(page)]="paginator.page" [pageSize]="paginator.size"
            [collectionSize]="paginator.total" (pageChange)="onPageChange($event)" [maxSize]="5"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
